exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-delete[data-v-3081beac],\n.hover-edit[data-v-3081beac] {\n  color: #6c757d;\n}\n.hover-delete[data-v-3081beac]:hover {\n  color: #dc3545;\n}\n.hover-edit[data-v-3081beac]:hover {\n  color: #ffc107;\n}\n.hover-row[data-v-3081beac]:hover {\n  cursor: pointer;\n  background: rgba(214, 69, 113, 0.1);\n}\n.selected[data-v-3081beac],\n.selected[data-v-3081beac]:hover {\n  background: #d64571;\n  color: white;\n}", ""]);

// exports
